module.exports = __webpack_public_path__ + "static/img/diy.2aa6b756.jpg";